// src/components/admin/AdminAuth.tsx
import React, { useState } from 'react';

const ADMIN_USERNAME = 'admin';
const ADMIN_PASSWORD = 'password123';

export default function AdminAuth({
  children,
}: {
  children: React.ReactNode;
}) {
  const [loggedIn, setLoggedIn] = useState(false);
  const [form, setForm] = useState({ username: '', password: '' });
  const [error, setError] = useState('');

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    if (
      form.username === ADMIN_USERNAME &&
      form.password === ADMIN_PASSWORD
    ) {
      setLoggedIn(true);
    } else {
      setError('Invalid credentials');
    }
  };

  if (loggedIn) return <>{children}</>;

  return (
    <div className="h-screen flex items-center justify-center bg-gray-50 p-4">
      <form
        onSubmit={submit}
        className="bg-white p-6 rounded shadow-md w-full max-w-sm"
      >
        <h2 className="text-xl font-semibold mb-4">Admin Login</h2>
        <input
          type="text"
          placeholder="Username"
          value={form.username}
          onChange={(e) =>
            setForm((f) => ({ ...f, username: e.target.value }))
          }
          className="w-full mb-3 p-2 border rounded"
        />
        <input
          type="password"
          placeholder="Password"
          value={form.password}
          onChange={(e) =>
            setForm((f) => ({ ...f, password: e.target.value }))
          }
          className="w-full mb-3 p-2 border rounded"
        />
        {error && <p className="text-red-500 mb-2">{error}</p>}
        <button className="w-full py-2 bg-blue-600 text-white rounded">
          Log in
        </button>
      </form>
    </div>
  );
}
